"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useAllowedRoles_1 = require("./useAllowedRoles");
const IfAllowedRoles = ({ children, roles = [] }) => {
    const allowed = useAllowedRoles_1.useAllowedRoles(roles);
    if (typeof children === 'function') {
        return children(allowed);
    }
    return allowed ? children : null;
};
exports.IfAllowedRoles = IfAllowedRoles;
//# sourceMappingURL=IfAllowedRoles.js.map